/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit MaxDiscount/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFormat from 'Data/format.js'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'



/** @type {import('Simple/types.js').View} */
export default function MaxDiscount({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/TreatmentCard/Content/TreatmentPlans/Steps/Content/PaymentPlans/Content/Content/PaymentPlan/Content/Content/Send/Content/Sidebar/Content/Overview/PlanRules/MaxDiscount"
  
}) {
let rulesetMaxDiscountValueData = fromData.useDataFormat({ viewPath,
context: 'ruleset',
path: 'max_discount',
format: fromFormat.percentage,
})
  return (<React.Fragment
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 weight="semibold"
 data="ruleset.max_discount"
 format="/Data/format.js percentage"
 text={rulesetMaxDiscountValueData}
/>
{children}
</React.Fragment>)
}